import React from 'react';
import './Speakers from.css';
import Glovo from "../../img/SF/Glovo.png";
import BlackAirplane from "../../img/SF/BlackAirplane.png";
import FormKit from "../../img/SF/FormKit.png";
import KarkinosHealthcare from "../../img/SF/KarkinosHealthcare.png";
import VueStorefront from "../../img/SF/VueStorefront.png";
import dept from "../../img/SF/dept.png";
import uniform from "../../img/SF/uniform.png";
import paper from "../../img/SF/paper.png";
import ww from "../../img/SF/ww.png";
import claranet from "../../img/SF/claranet.png";
import fingerprint from "../../img/SF/fingerprint.png";
import mirrorworld from "../../img/SF/mirrorworld.png";
import github from "../../img/SF/github.png";
import zalando from "../../img/SF/zalando.png";
import microsoft from "../../img/SF/microsoft.png";
import axion from "../../img/SF/axion.png";
import garmin from "../../img/SF/garmin.png";
import shopware from "../../img/SF/shopware.png";
import aquamet from "../../img/SF/aquamet.png";

const SpeakersFrom = () => {
    const state = {
        Speakers_item: [
            {
                img: BlackAirplane,
            },
            {
                img: KarkinosHealthcare,
            },
            {
                img: VueStorefront,
            },
            {
                img: FormKit,
            },
            {
                img: Glovo,
            },
            {
                img: dept,
            },
            {
                img: uniform,
            },
            {
                img: paper,
            },
            {
                img: ww,
            },
            {
                img: claranet,
            },
            {
                img: fingerprint,
            },
            {
                img: mirrorworld,
            },
            {
                img: github,
            },
            {
                img: zalando,
            },
            {
                img: microsoft,
            },
            {
                img: axion,
            },
            {
                img: garmin,
            },
            {
                img: shopware,
            },
            {
                img: aquamet,
            },
            {
                img: VueStorefront,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <section className="speakers_from_wrap red_grad">
            <div className="container">
                <h2>Speakers from</h2>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </section>
    );
};

export default SpeakersFrom;